// VORLICH — reveal-on-scroll (respects reduced-motion). Re-arms when the
// theme editor / dev server swaps a section (shopify:section:load), otherwise
// replaced .rv nodes would stay at opacity 0.
(function () {
  var reduced = (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) || !('IntersectionObserver' in window);
  var io = null;
  if (!reduced) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.14 });
  }
  function arm(root) {
    (root || document).querySelectorAll('.rv:not(.in)').forEach(function (e) {
      if (io) { io.observe(e); } else { e.classList.add('in'); }
    });
  }
  arm();
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();

// Mobile nav drawer — accessible (focus trap, Esc, close on navigate)
(function () {
  var t = document.getElementById('navToggle'), d = document.getElementById('navDrawer');
  if (!t || !d) return;
  var closeBtn = document.getElementById('navClose'), backdrop = document.getElementById('navBackdrop');
  var last = null;
  function openD() {
    last = document.activeElement; d.hidden = false; t.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('.navdrawer__menu a, button, select'); if (f) f.focus();
  }
  function closeD() {
    d.hidden = true; t.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    if (last) { try { last.focus(); } catch (e) {} }
  }
  t.addEventListener('click', openD);
  if (closeBtn) closeBtn.addEventListener('click', closeD);
  if (backdrop) backdrop.addEventListener('click', closeD);
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeD(); return; }
    if (e.key === 'Tab') {
      var f = d.querySelectorAll('a[href], button:not([disabled]), select'); if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }
  });
  d.querySelectorAll('.navdrawer__menu a').forEach(function (a) { a.addEventListener('click', closeD); });
})();
